import { render } from "./CookieInfoModal.vue?vue&type=template&id=6983e552&scoped=true&ts=true"
import script from "./CookieInfoModal.vue?vue&type=script&lang=ts"
export * from "./CookieInfoModal.vue?vue&type=script&lang=ts"

import "./CookieInfoModal.vue?vue&type=style&index=0&id=6983e552&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6983e552"]])

export default __exports__